import { Directive, ElementRef, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { Router } from '@angular/router';
import * as uuid from 'uuid';
import { modals } from '../singletons/modals';
import { Modal } from 'bootstrap';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appModal]',
  exportAs: 'modal'
})
export class ModalDirective implements OnInit, OnDestroy {

  private static MODAL_EVENTS = 'hidden.bs.modal shown.bs.modal hide.bs.modal show.bs.modal';

  // $el: any;
  modal: any;

  id;

  private backdrop = '.modal-backdrop';

  constructor(
    private el: ElementRef,
    private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.id = 'm' + uuid.v4();
    this.el.nativeElement.setAttribute('aria-labelledby', `${this.id}-title`);
    this.el.nativeElement.setAttribute('aria-hidden', 'true');
    this.el.nativeElement.setAttribute('tabindex', -1);
    this.el.nativeElement.setAttribute('role', 'dialog');
    this.renderer.addClass(this.el.nativeElement, 'modal');
    this.renderer.addClass(this.el.nativeElement, 'animated');
    this.renderer.addClass(this.el.nativeElement, 'fade');
    // this.$el = $(this.el.nativeElement);
  }

  ngOnInit() {
    this.modal = new Modal(this.el.nativeElement, { keyboard: false, backdrop: 'static'});
    this.el.nativeElement.addEventListener(ModalDirective.MODAL_EVENTS, ({ type }: any) => {
      this.invoke(type);
    });
  }

  ngOnDestroy() {
    const el = this.document.querySelector(this.backdrop);
    if (el) {
      el.classList.remove('show');
      setTimeout(() => {
        if (el.parentNode !== null) {
          el.parentNode.removeChild(el);
        }
      }, 300);
    }
  }

  private invoke(event: string) {
    (this as any)[event + 'Callback']();
    // this[event].emit(this)
  }

  show() {
    this.modal.show();
  }

  hide(delay?: boolean) {
    if (delay === true) {
      setTimeout(() => this.modal.hide(), 1000);
      return;
    }
    this.modal.hide()
    // this.$el.modal('hide');
  }

  private hiddenCallback() {
    this.router.navigate([{ outlets: { modal: null }}]);
    modals.events.emit({ event: 'hidden modal', data: true });
  }

  private hideCallback() {
  }

  private showCallback() {
  }

  private shownCallback() {
  }

}
